import {  getBaseURLforBackEnd , getConfigAxios , myTimeZone }  from '@/utils.js'
import axios from "axios";
import master_data  from './master_data';
import moment from 'moment-timezone' 

export default {
    namespaced: true,

    state: {
        dateWeblog1 : new Date(),
        dataWeblog1 : [],
        countTotal : 0,
        first : 10000,
        skip : 0
    },

    getters: {

    },

    mutations: {
        setDateWeblog1 (state, dateWeblog1) {
            state.dateWeblog1 = dateWeblog1
        },

        setDataWeblog1 (state, dataWeblog1) {
            state.dataWeblog1 = dataWeblog1
        },

        setCountTotal (state, countTotal) {
            state.countTotal = countTotal
        },

        setFirst (state, first) {
            state.first = first
        },


        setSkip (state, skip) {
            state.skip = skip
        },

        // pushDataWeblog1(state, payload) {
        //     state.dataWeblog1 = state.dataWeblog1.concat(payload);
        // }
        //

    },

    actions: {

        fetchDataWeblog1Count({commit,state}) {
            const date_selected =  moment.tz(   state.dateWeblog1 , myTimeZone).format('YYYY-MM-DD') +'T00:00:00.000Z'
            const datTo = {
                "date_selected" : date_selected
            }
            //  console.log(JSON.stringify(datTo))
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${ master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/listweblog1count`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setCountTotal', res.data.count)
                        resolve(res.data)
                    })
                    .catch(err =>{
                        resolve(err)
                    })
            }    )

        },

        fetchDataWeblog1({state}) {
            const date_selected = moment.tz(state.dateWeblog1, myTimeZone).format('YYYY-MM-DD') + 'T00:00:00.000Z';
            const datTo = {
                date_selected,
                first: state.first,
                skip: state.skip,
            };

            return axios.post(`${getBaseURLforBackEnd()}/api/listweblog1`, datTo, getConfigAxios())
                .then(res => res.data)
                .catch(() => []);
        }



        // fetchDataWeblog1({commit, state}) {
        //     const date_selected = moment.tz(state.dateWeblog1, myTimeZone).format('YYYY-MM-DD') + 'T00:00:00.000Z';
        //
        //     const datTo = {
        //         date_selected,
        //         first: state.first,
        //         skip: state.skip
        //     };
        //
        //     return new Promise(resolve => {
        //         axios.defaults.headers.common['Authorization'] = `Bearer ${ master_data.state.access_token }`;
        //
        //         axios.post(`${getBaseURLforBackEnd()}/api/listweblog1`, datTo, getConfigAxios())
        //             .then(res => {
        //                 commit('pushDataWeblog1', res.data);    // ← ใช้มิวเทชัน
        //                 resolve(res.data);
        //             })
        //             .catch(err => {
        //                 resolve(err);
        //             });
        //     });
        // }




        // fetchDataWeblog1({state}) {
        //    const date_selected =  moment.tz(   state.dateWeblog1 , myTimeZone).format('YYYY-MM-DD') +'T00:00:00.000Z'
        //    const datTo = {
        //         "date_selected" : date_selected,
        //         "first" : state.first,
        //         "skip" : state.skip
        //      }
        //      console.log(JSON.stringify(datTo))
        //     return new Promise((resolve) => {
        //         axios.defaults.headers.common['Authorization'] = `Bearer ${ master_data.state.access_token}`
        //         axios.post(`${getBaseURLforBackEnd()}/api/listweblog1`,datTo,getConfigAxios())
        //             .then((res)=>{
        //                 // commit('setDataWeblog1', res.data)
        //                 // state.dataWeblog1.concat(res.data);
        //                 state.dataWeblog1 = state.dataWeblog1.concat(res.data);
        //                 resolve(res.data);
        //             })
        //             .catch(err =>{
        //                 resolve(err);
        //             })
        //     }    )
        //
        // },







         
    }
}